import { Table } from "reactstrap";
import {  H6 } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";

const ViewAppsSection = ({orgData}:any) => {
    console.log(orgData,"admin");
    const {t}=useTranslation()
    
  return (
    <td>
      <Table className="bill-content w-100">
        <tbody>
        <tr>
            <td style={{ width: "21%" }}>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("OrganizationBrowserGoogleKey")}</span>
              <H6 style={{ width: "46%" }}>
                {orgData?.GoogleKey? orgData?.GoogleKey : "N/A"} 
              </H6>
            </td>
            <td style={{ width: "21%" }}>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("EmployeeAppAndroidKey")}</span>
              <H6>{orgData.androidKey? orgData.androidKey : "N/A"}</H6>
            </td>
            <td>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("EmployeeAppAndroidURL")}</span>
              <H6>{orgData.androidURL? orgData.androidURL : "N/A"}</H6>
            </td>
            <td>
              <span style={{ opacity: "0.8" ,color:"#757272"}}>{t("EmployeeAppIOSKey")}</span>
              <H6>{orgData.iosKey? orgData.iosKey : "N/A"}</H6>
            </td>
            <td>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("EmployeeAppIOSURL")}</span>
              <H6>{orgData.iosURL? orgData.iosURL : "N/A"}</H6>
            
            </td>
           
          </tr>
          
        
        </tbody>
      </Table>
    </td>
  );
};

export default ViewAppsSection;
